"use client";

import React, { useState, FormEvent, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Box,
  InputBase,
  Typography,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  InputLabel,
  Alert,
  FormControl,
  Popover,
} from "@mui/material";
import LoginIcon from "@mui/icons-material/Login";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import CloseIcon from "@mui/icons-material/Close";
import logo from "../assets/logo.png";
import { useNavigate } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import HomeIcon from "@mui/icons-material/Home";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import LibraryMusicIcon from "@mui/icons-material/LibraryMusic";
import ContactsIcon from "@mui/icons-material/Contacts";
import SettingsIcon from "@mui/icons-material/Settings";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import LogoutIcon from "@mui/icons-material/Logout";
import { Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../redux/store";
import { login, logout } from "../redux/slices/authSlice";
import CustomButton from "./CustomButton";
import axios from "axios";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { clearPhoneData, setPhoneData } from "../redux/slices/phoneSlice";
import { clearProfile, setProfileData } from "../redux/slices/profileSlice";
import RefreshIcon from "@mui/icons-material/Refresh";

interface Country {
  countryCode: string;
  countryName: string;
  url: string;
}

interface LoginFormValues {
  country: string;
  phone: string;
  password: string;
}

interface AlertMessage {
  severity: "success" | "error" | "info" | "warning";
  text: string;
}

interface SignupFormValues {
  country: string;
  phone: string;
  name: string;
  password: string;
  confirm: string;
}

const Navbar: React.FC = () => {
  const navigate = useNavigate();

  const [openLogin, setOpenLogin] = useState(false);
  const [openSignup, setOpenSignup] = useState(false);

  const [loginError, setLoginError] = useState("");

  const [signupCountry, setSignupCountry] = useState("");
  const [signupPhone, setSignupPhone] = useState("");
  const [signupPassword, setSignupPassword] = useState("");
  const [afterOtpSignupOpen, setAfterOtpSignupOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [forgotCountry, setForgotCountry] = useState("");
  const [showOtpForm, setShowOtpForm] = useState(false);
  const [alerts, setAlerts] = useState<AlertMessage[]>([]);
  const [forgotPhone, setForgotPhone] = useState("");
  const [signupMsg, setSignupMsg] = useState<{
    type: "error" | "success";
    text: string;
  } | null>(null);
  const [countryList, setCountryList] = useState<Country[]>([]);
  const dispatch = useDispatch();
  const { isLoggedIn } = useSelector((state: RootState) => state.auth);
  const [openContact, setOpenContact] = useState(false);
  const [registeredName, setRegisteredName] = useState("");
  const [registeredEmail, setRegisteredEmail] = useState("");
  const [showHelpBox, setShowHelpBox] = useState(false);
  const [openPricing, setOpenPricing] = useState(false);
  const [openLoginOtpPopup, setOpenLoginOtpPopup] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [captcha, setCaptcha] = useState("");
  const [captchaInput, setCaptchaInput] = useState("");
  const [captchaError, setCaptchaError] = useState("");
  const [loginOtp, setLoginOtp] = useState("");
  const [loginCountry, setLoginCountry] = useState("");
  const [loginMsisdn, setLoginMsisdn] = useState("");
  const [forgotOtp, setForgotOtp] = useState("");
  const [openForgotOtpPopup, setOpenForgotOtpPopup] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [openNewPasswordPopup, setOpenNewPasswordPopup] = useState(false);
  const [loggedInUser, setLoggedInUser] = useState<any | null>(null);


   const { countryCode, msisdn } = useSelector(
      (state: RootState) => state.phone
    );

  const {
    register: registerLogin,
    handleSubmit: handleLoginSubmit,
    formState: { errors: loginErrors },
    reset: resetLogin,
  } = useForm<LoginFormValues>();

  const handleForgotSubmit = async (e: FormEvent) => {
  e.preventDefault();

  if (!forgotPhone || forgotPhone.length < 6) {
    alert("Please Enter a valid phone number must have 7 digits.");
  }

  const username = forgotCountry + forgotPhone;

      try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/Authenticate/sendOtpOnLogin?msisdn=${username}&service=${process.env.REACT_APP_SERVICE}&interface=${process.env.REACT_APP_INTERFACES}&langId=${process.env.REACT_APP_LANGID}`);

      if(res?.data?.resCode === 154){
        alert(res?.data?.resMessage)
        setOpenForgotOtpPopup(true);
        setOpenLogin(false);
      }else {
        alert(res?.data?.resMessage);
        // dispatch(logout());
      }
      
    } catch (error) {
      console.log(error)
    }
};

const handleSubmitForgotOtp = async () => {
  try {
    const username = forgotCountry + forgotPhone;

    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/Authenticate/verifyOTP?msisdn=${username}&service=${process.env.REACT_APP_SERVICE}&interface=${process.env.REACT_APP_INTERFACES}&langId=${process.env.REACT_APP_LANGID}&otp=${forgotOtp}`
    );

    if (res.data.resCode === 169) {
      setOpenForgotOtpPopup(false);
      setOpenNewPasswordPopup(true);
      alert(res.data.resMessage);
    } else {
        alert(res.data.resMessage);
    }
  } catch (err) {
    console.error(err);
  }
};

const handleResetPassword = async () => {
  if (!newPassword || !confirmPassword) {
    alert("Please Fill all fields.")
  }

  if (newPassword !== confirmPassword) {
   alert("Passwords do not match.");
  }

  const username = forgotCountry + forgotPhone;

const res = await axios.put(
      `${process.env.REACT_APP_API_URL}/Authenticate/changePassword?msisdn=${username}&service=${process.env.REACT_APP_SERVICE}&interface=${process.env.REACT_APP_INTERFACES}&langId=${process.env.REACT_APP_LANGID}&newPass=${newPassword}`
    );

  if (res.data.resCode === 265) {
    alert(res.data.resMessage);
    setOpenNewPasswordPopup(false);
  } else {
        alert(res.data.resMessage);
  }
};


  const handleSubmitRegistration = async () => {
    const username = signupCountry + signupPhone;
    const password = signupPassword;

    try {
      const url = `${process.env.REACT_APP_API_URL}/Authenticate/SIGNUP?
      msisdn=${username}
      &service=${process.env.REACT_APP_SERVICE}
      &interface=${process.env.REACT_APP_INTERFACES}
      &langId=${process.env.REACT_APP_LANGID}
      &name=${registeredName}
      &email=${registeredEmail}
      &password=${password}`.replace(/\s+/g, "");

      const res = await axios.post(url);

      if (res?.data?.resCode === 122) {
        alert(res?.data?.resMessage || "Signup successful!");

        setOpenSignup(false);
        setAfterOtpSignupOpen(false);
        setSignupPhone("");

        dispatch(
          setPhoneData({
            countryCode: signupCountry,
            msisdn: signupPhone,
          })
        );

        dispatch(logout());

      } else {
        alert(res?.data?.resMessage || "Signup failed");
      }
    } catch (error: any) {
      console.error("Signup error:", error);
      setSignupMsg({
        type: "error",
        text:
          error.response?.data?.message ||
          "Signup failed! Please try again later.",
      });
    }
  };

const handleLoginOtp = async () => {
  try {
    const username = loginCountry + loginMsisdn;

    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/Authenticate/verifyOTP?msisdn=${username}&service=${process.env.REACT_APP_SERVICE}&interface=${process.env.REACT_APP_INTERFACES}&langId=${process.env.REACT_APP_LANGID}&otp=${loginOtp}`
    );



    if(res.data.resCode === 169){
      alert(res.data.resMessage);
      dispatch(login(loggedInUser));
      navigate('/flowtone/dashboard')
    } else {
      alert(res.data.resMessage)
      dispatch(logout());
    }

  } catch (error) {
    console.error("OTP Error:", error);
  }
};


  const generateCaptcha = () => {
    const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
    let result = "";
    for (let i = 0; i < 6; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    setCaptcha(result);
  };

  const {
    register: registerSignup,
    handleSubmit: handleSignupSubmit,
    formState: { errors: signupErrors },
    reset: resetSignup,
  } = useForm<SignupFormValues>();

  const submitSignup = async (data: SignupFormValues) => {
    const username = signupCountry + data.phone;

    try {
      const signupUrl = `${process.env.REACT_APP_API_URL}/Authenticate/SENDOTP?msisdn=${username}&service=${process.env.REACT_APP_SERVICE}&interface=${process.env.REACT_APP_INTERFACES}&langId=${process.env.REACT_APP_LANGID}`;

      const res = await axios.get(signupUrl);

      if (res?.data?.resCode === 154) {
        alert(res?.data?.resMessage || "Otp Sent!");
        setAfterOtpSignupOpen(true);

        dispatch(
          setPhoneData({
            countryCode: data?.country,
            msisdn: data?.phone,
          })
        );
      } else {
        alert(res?.data?.resMessage || "Otp Sent failed");
      }
    } catch (error: any) {
      console.error("Signup Error:", error);

      setSignupMsg({
        type: "error",
        text: error.response?.data?.message || "Signup failed",
      });
    }
  };

  const handleSearch = async () => {
    if (!searchText.trim()) return;

    navigate("/flowtone/searchResults", {
      state: {
        searchText,
      },
    });
  };

  const handleLoginSendOtp = async () => {

    const username = loginCountry + loginMsisdn;

    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/Authenticate/sendOtpOnLogin?msisdn=${username}&service=${process.env.REACT_APP_SERVICE}&interface=${process.env.REACT_APP_INTERFACES}&langId=${process.env.REACT_APP_LANGID}`);

      if(res?.data?.resCode === 154){
        alert(res?.data?.resMessage)
      }else {
        alert(res?.data?.resMessage);
        dispatch(logout());
      }
      
    } catch (error) {
      console.log(error)
    }
    
  }

  const getProfileData = async (countryCode: any, msisdn: any) => {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/Content/ProfileData?msisdn=${
        countryCode + msisdn
      }&service=${process.env.REACT_APP_SERVICE}&interface=${
        process.env.REACT_APP_INTERFACES
      }&langId=${process.env.REACT_APP_LANGID}&countryCode=${countryCode}`
    );
    dispatch(
      setProfileData({
        subType: res?.data?.crbtProfile?.subType,
        albumList: res?.data?.crbtProfile?.albumList,
        plan: res?.data?.crbtProfile?.plan,
      })
    );
  };

  const submitLogin = async (data: LoginFormValues) => {
    setCaptchaError("");
    

    if (captchaInput.toUpperCase() !== captcha.toUpperCase()) {
      setCaptchaError("Invalid captcha. Please try again.");
      generateCaptcha(); 
      return;
    }

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/Authenticate/USERLOGIN?msisdn=${
          loginCountry + loginMsisdn
        }&service=${process.env.REACT_APP_SERVICE}&interface=${
          process.env.REACT_APP_INTERFACES
        }&langId=${process.env.REACT_APP_LANGID}&password=${data.password}`
      );

      if (res?.data?.resCode === 200) {
        alert(res?.data?.resMessage);
        setLoggedInUser(res.data.user);
        // dispatch(login(res.data.user));
        dispatch(
          setPhoneData({ countryCode: loginCountry, msisdn: loginMsisdn })
        );
        await getProfileData(loginCountry, loginMsisdn);

        setOpenLogin(false);
        resetLogin();
        setCaptchaInput("");
        generateCaptcha();
        await handleLoginSendOtp();
        setOpenLoginOtpPopup(true);
      } else {
        alert(res?.data.resMessage);
      }
    } catch (error: any) {
      setLoginError(error.response?.data?.message || "Login failed");
    }
  };

  const handleLogout = () => {
    dispatch(logout());
    dispatch(clearPhoneData());
    dispatch(clearProfile());
    setAnchorEl(null);
    navigate("/flowtone/login");
  };

  const getCountries = async () => {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/Cache/GetCountries?service=${process.env.REACT_APP_SERVICE}&interface=${process.env.REACT_APP_INTERFACES}&langId=${process.env.REACT_APP_LANGID}`
    );

    setCountryList(res?.data?.countryList);
  };

  useEffect(() => {
 
  if (countryList.length > 0 && !signupCountry) {
    setSignupCountry(countryList[0]?.countryCode);
  }
}, [countryList, signupCountry]);

  useEffect(() => {
    if (!countryList) return;

    setForgotCountry(countryList[0]?.countryCode);
  }, [countryList]);

  useEffect(() => {
    getCountries();
  }, []);

  useEffect(() => {
    if (openLogin) generateCaptcha();
  }, [openLogin]);

  return (
    <>
      <AppBar
        position="fixed"
        sx={{ backgroundColor: "#5c5959", boxShadow: "none", height: 70 }}
      >
        <Toolbar sx={{ display: "flex", alignItems: "center" }}>
          {/* Logo */}
          <Box sx={{ width: "33%", display: "flex", alignItems: "center" }}>
            <img
              src={logo}
              alt="Flow Tones Logo"
              style={{ width: "150px", height: "45px", marginTop: 8 }}
            />
          </Box>

          {/* Search */}
          <Box sx={{ width: "33%", display: "flex", justifyContent: "center" }}>
            <InputBase
              placeholder="Search..."
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch();
                }
              }}
              sx={{
                background: "#f1f1f1",
                px: 1,
                py: 1,
                borderRadius: 1,
                width: "100%",
                maxWidth: 350,
                height: 32,
                fontSize: 14,
              }}
            />
          </Box>

          <Box
            sx={{
              width: "33%",
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            {!isLoggedIn ? (
              <>
                {/* Login Button */}
                <Box
                  sx={{
                    backgroundColor: "#0085cd",
                    width: "42px",
                    height: "42px",
                    borderRadius: "50%",
                    display: "flex",
                    mr: 1,
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                    "&:hover .icon": { display: "none" },
                    "&:hover .text": { display: "block" },
                  }}
                  onClick={() => setOpenLogin(true)}
                >
                  <LoginIcon
                    className="icon"
                    sx={{ fontSize: 16, color: "white" }}
                  />
                  <Typography
                    className="text"
                    sx={{
                      display: "none",
                      fontSize: 12,
                      fontWeight: 500,
                      color: "white",
                    }}
                  >
                    Login
                  </Typography>
                </Box>

                {/* Signup Button */}
                <Box
                  sx={{
                    backgroundColor: "#0085cd",
                    width: 42,
                    height: 42,
                    borderRadius: "50%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                    color: "#fff",
                    "&:hover .icon": { display: "none" },
                    "&:hover .text": { display: "block" },
                  }}
                  onClick={() => setOpenSignup(true)}
                >
                  <PersonAddIcon className="icon" sx={{ fontSize: 16 }} />
                  <Typography
                    className="text"
                    sx={{ display: "none", fontSize: 12, fontWeight: 500 }}
                  >
                    Signup
                  </Typography>
                </Box>
              </>
            ) : (
              <>
                {/* Hamburger Menu */}
                <IconButton
                  onClick={(e) => setAnchorEl(e.currentTarget)}
                  sx={{ color: "#0085cd" }}
                >
                  <MenuIcon sx={{ fontSize: 40 }} />
                </IconButton>

                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={() => setAnchorEl(null)}
                  PaperProps={{
                    sx: {
                      mt: 1.5,
                      minWidth: 220,
                      backgroundColor: "#5c5959",
                      color: "#fff",
                      "& .MuiMenuItem-root:hover": {
                        backgroundColor: "#6c6a6a",
                      },
                    },
                  }}
                >
                  <MenuItem onClick={() => navigate("/flowtone")}>
                    <ListItemIcon>
                      <HomeIcon sx={{ color: "#fff" }} />
                    </ListItemIcon>
                    <ListItemText primary="Tones Central" />
                  </MenuItem>
                  <MenuItem onClick={() => navigate("/flowtone/store")}>
                    <ListItemIcon>
                      <ShoppingCartIcon sx={{ color: "#fff" }} />
                    </ListItemIcon>
                    <ListItemText primary="Tones Store" />
                  </MenuItem>
                  <MenuItem onClick={() => navigate("/flowtone/myTones")}>
                    <ListItemIcon>
                      <LibraryMusicIcon sx={{ color: "#fff" }} />
                    </ListItemIcon>
                    <ListItemText primary="My Tones Library" />
                  </MenuItem>
                  <MenuItem onClick={() => navigate("/flowtone/myContacts")}>
                    <ListItemIcon>
                      <ContactsIcon sx={{ color: "#fff" }} />
                    </ListItemIcon>
                    <ListItemText primary="My Contacts" />
                  </MenuItem>
                  <MenuItem onClick={() => navigate("/flowtone/toneSetting")}>
                    <ListItemIcon>
                      <SettingsIcon sx={{ color: "#fff" }} />
                    </ListItemIcon>
                    <ListItemText primary="Tones Settings" />
                  </MenuItem>
                  <MenuItem onClick={() => navigate("/flowtone/promos")}>
                    <ListItemIcon>
                      <LocalOfferIcon sx={{ color: "#fff" }} />
                    </ListItemIcon>
                    <ListItemText primary="My Promos" />
                  </MenuItem>
                  <MenuItem onClick={() => navigate("/flowtone/profile")}>
                    <ListItemIcon>
                      <AccountCircleIcon sx={{ color: "#fff" }} />
                    </ListItemIcon>
                    <ListItemText primary="My Profile" />
                  </MenuItem>
                  <MenuItem
                    onMouseEnter={() => setShowHelpBox(true)}
                    onMouseLeave={() => setShowHelpBox(false)}
                    sx={{ position: "relative" }}
                  >
                    <ListItemIcon>
                      <HelpOutlineIcon sx={{ color: "#fff" }} />
                    </ListItemIcon>
                    <ListItemText primary="Help" />

                    {showHelpBox && (
                      <Box
                        onMouseEnter={() => setShowHelpBox(true)}
                        onMouseLeave={() => setShowHelpBox(false)}
                        sx={{
                          position: "fixed",
                          top: anchorEl
                            ? anchorEl.getBoundingClientRect().top + 330
                            : 0,
                          left: anchorEl
                            ? anchorEl.getBoundingClientRect().left - 320
                            : 0,
                          background: "#5c5959",
                          color: "#fff",
                          p: 1.5,
                          minWidth: 170,
                          borderRadius: 1,
                          zIndex: 2000,
                          boxShadow: "0 3px 10px rgba(0,0,0,0.3)",
                        }}
                      >
                        <MenuItem
                          onClick={() => {
                            setShowHelpBox(false);
                            setOpenPricing(true);
                          }}
                        >
                          Pricing Info
                        </MenuItem>

                        <MenuItem onClick={() => navigate("/flowtone/faq")}>
                          FAQs
                        </MenuItem>
                        <MenuItem
                          onClick={() => {
                            setShowHelpBox(false);
                            setOpenContact(true);
                          }}
                        >
                          Contact Info
                        </MenuItem>
                      </Box>
                    )}
                  </MenuItem>

                  <MenuItem>
                    <ListItemIcon>
                      <LogoutIcon sx={{ color: "#fff" }} />
                    </ListItemIcon>
                    <ListItemText primary="Log out" onClick={handleLogout} />
                  </MenuItem>
                </Menu>
              </>
            )}
          </Box>
        </Toolbar>
      </AppBar>

      <Dialog
        open={openContact}
        onClose={() => setOpenContact(false)}
        fullWidth
        maxWidth="md"
        PaperProps={{
          sx: {
            borderRadius: 2,
            width: "500px",
            maxWidth: "500px",
          },
        }}
      >
        <DialogTitle
          sx={{
            fontSize: 18,
            fontWeight: 600,
            color: "#000",
            pr: 5,
            position: "relative",
          }}
        >
          Contact For Billing
          <IconButton
            onClick={() => setOpenContact(false)}
            sx={{ position: "absolute", top: 8, right: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent
          dividers
          sx={{
            fontSize: 15,
            lineHeight: 1.6,
            color: "#000",
            p: 3,
          }}
        >
          <p>You can call 444288 for any billing query.</p>
          <br />
          <p>You can call xxxxx8 for any billing query.</p>
        </DialogContent>

        <DialogActions sx={{ p: 2 }}>
          <Button
            variant="contained"
            sx={{
              background: "#4d92d9",
              textTransform: "capitalize",
            }}
            onClick={() => setOpenContact(false)}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openPricing}
        onClose={() => setOpenPricing(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            maxWidth: 500,
          },
        }}
      >
        <DialogTitle
          sx={{
            fontSize: 18,
            fontWeight: 600,
            color: "#000",
            pr: 5,
            position: "relative",
          }}
        >
          Terms and Conditions
          <IconButton
            onClick={() => setOpenPricing(false)}
            sx={{ position: "absolute", top: 8, right: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent
          dividers
          sx={{
            fontSize: 15,
            lineHeight: 1.6,
            color: "#000",
            p: 3,
          }}
        >
          <p>About Us- Flow-</p>
          <p>Hello Thanks.</p>
        </DialogContent>

        <DialogActions sx={{ p: 2 }}>
          <CustomButton text="Ok" onClick={() => setOpenPricing(false)} />
        </DialogActions>
      </Dialog>

      <Dialog
        open={openLogin}
        onClose={() => setOpenLogin(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{ position: "relative", pr: 5, fontSize: 18, color: "#0085CA" }}
        >
          Login
          <IconButton
            onClick={() => setOpenLogin(false)}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers sx={{ py: 4, px: 6 }}>
          <Box component="form" onSubmit={handleLoginSubmit(submitLogin)}>
            <InputLabel sx={{ fontSize: 14, color: "#000", fontWeight: 700 }}>
              Country
            </InputLabel>
            <Select
              sx={{ mb: 2 }}
              fullWidth
              size="small"
              // onChange={(e) => setSignupCountry(e.target.value)}
              defaultValue={countryList[0]?.countryCode}
              onChange={(e) => setLoginCountry(e.target.value)}
              // {...registerLogin("country", { required: true })}
            >
              {countryList?.map((c) => (
                <MenuItem key={c.countryCode} value={c.countryCode}>
                  {c.countryName} ({c.countryCode})
                </MenuItem>
              ))}
            </Select>

            <InputLabel sx={{ fontSize: 14, color: "#000", fontWeight: 700 }}>
              Phone Number
            </InputLabel>
            <TextField
              sx={{ mb: 2 }}
              fullWidth
              size="small"
              value={loginMsisdn}
              onChange={(e) => setLoginMsisdn(e.target.value)}
              // {...registerLogin("phone", {
              //   required: "Phone required",
              //   minLength: { value: 6, message: "Invalid phone number" },
              // })}
            />

            <InputLabel sx={{ fontSize: 14, color: "#000", fontWeight: 700 }}>
              Password
            </InputLabel>
            <TextField
              sx={{ mb: 3 }}
              fullWidth
              size="small"
              type="password"
              {...registerLogin("password", { required: "Password required" })}
            />

            <Box sx={{ mb: 2 }}>
              <InputLabel sx={{ fontSize: 14, color: "#000", fontWeight: 700 }}>
                Captcha
              </InputLabel>

              <Box display="flex" alignItems="center" gap={2}>
                <TextField
                  fullWidth
                  size="small"
                  placeholder="Enter Captcha"
                  value={captchaInput}
                  onChange={(e) => setCaptchaInput(e.target.value)}
                />

             
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    mt: 1,
                    mb: 1,
                  }}
                >
                  <Box
                    sx={{
                      background: "#e3e3e3",
                      padding: "8px 16px",
                      fontSize: 20,
                      letterSpacing: 3,
                      fontWeight: "bold",
                      borderRadius: 1,
                      userSelect: "none",
                    }}
                  >
                    {captcha}
                  </Box>

                  {/* Refresh button */}
                  <Button
                    onClick={generateCaptcha}
                    sx={{ textTransform: "capitalize", fontSize: 12 }}
                  >
                    <RefreshIcon />
                  </Button>
                </Box>
              </Box>

              {/* Captcha Input */}
            </Box>
               {captchaError && (
                  <Alert severity="error" sx={{ mt: 1,mb:1 }}>
                    {captchaError}
                  </Alert>
                )}

            {/* {loginError && (
              <Alert severity="error" sx={{ mb: 1 }}>
                {loginError}
              </Alert>
            )} */}

            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{
                textTransform: "capitalize",
                border: "2px solid #4d92d9",
                background: "#4d92d9",
                ":hover": {
                  background: "transparent",
                  color: "#4d92d9",
                  transition: "0.4s",
                },
              }}
            >
              Login
            </Button>
            <Box display={"flex"} justifyContent="flex-end">
              <Button
                sx={{
                  mt: 1,
                  textTransform: "capitalize",
                  textDecoration: "underline",
                }}
                onClick={() => setShowOtpForm(true)}
              >
                Forgot Password?
              </Button>
            </Box>

            {showOtpForm && (
              <Box
                component="form"
                // onSubmit={handleForgotSubmit}
                sx={{ mt: 2 }}
              >
                <InputLabel
                  sx={{ fontSize: 14, color: "#000", fontWeight: 700 }}
                >
                  Country
                </InputLabel>
                <Select
                  fullWidth
                  size="small"
                  value={forgotCountry}
                  onChange={(e) => setForgotCountry(e.target.value)}
                  sx={{ mb: 1 }}
                >
                  {countryList?.map((c, i) => (
                    <MenuItem key={i} value={c.countryCode}>
                      {c.countryName} ({c.countryCode})
                    </MenuItem>
                  ))}
                </Select>

                <InputLabel
                  sx={{ fontSize: 14, color: "#000", fontWeight: 700 }}
                >
                  Phone Number
                </InputLabel>
                <TextField
                  fullWidth
                  size="small"
                  value={forgotPhone}
                  onChange={(e) => setForgotPhone(e.target.value)}
                  placeholder="Phone Number"
                />

                <Button
                  onClick={handleForgotSubmit}        
                  // type="submit"
                  variant="contained"
                  sx={{
                    mt: 1,
                    border: "2px solid #4d92d9",
                    background: "#4d92d9",
                    ":hover": {
                      background: "transparent",
                      color: "#4d92d9",
                      transition: "0.4s",
                    },
                  }}
                >
                  Submit
                </Button>
              </Box>
            )}
          </Box>
        </DialogContent>
      </Dialog>

      <Dialog
  open={openLoginOtpPopup}
  onClose={() => {
    setOpenLoginOtpPopup(false)
    dispatch(logout());
  }}
  maxWidth="sm"
  fullWidth
>
  <DialogTitle
    sx={{ position: "relative", pr: 5, fontSize: 18, color: "#0085CA" }}
  >
    Login
    <IconButton
      onClick={() => {
        setOpenLoginOtpPopup(false)
        dispatch(logout());
      }}
      sx={{ position: "absolute", right: 8, top: 8 }}
    >
      <CloseIcon />
    </IconButton>
  </DialogTitle>

  <DialogContent dividers sx={{ py: 4, px: 6 }}>
    <Box component="form">
      <InputLabel sx={{ fontSize: 14, color: "#000", fontWeight: 700 }}>
        OTP
      </InputLabel>
      <TextField
        fullWidth
        size="small"
        sx={{ mb: 3 }}
        value={loginOtp}
        onChange={(e) => setLoginOtp(e.target.value)}
      />

      <Button
      onClick={handleLoginOtp}
        // type="submit"
        fullWidth
        variant="contained"
        sx={{
          textTransform: "capitalize",
          border: "2px solid #4d92d9",
          background: "#4d92d9",
          ":hover": {
            background: "transparent",
            color: "#4d92d9",
            transition: "0.4s",
          },
        }}
      >
        Submit
      </Button>

    </Box>
  </DialogContent>
</Dialog>


      <Dialog
        open={openSignup}
        onClose={() => setOpenSignup(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{ position: "relative", pr: 5, fontSize: 18, color: "#0085CA" }}
        >
          SignUp
          <IconButton
            onClick={() => setOpenSignup(false)}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers sx={{ py: 4, px: 9 }}>
          <Box component="form" onSubmit={handleSignupSubmit(submitSignup)}>
            <Box display="flex" alignItems="center" mb={2}>
              <InputLabel
                sx={{
                  fontSize: 14,
                  color: "#000",
                  fontWeight: 700,
                  minWidth: "120px",
                  mr: 2,
                }}
              >
                Country
              </InputLabel>
              <Select
                fullWidth
                size="small"
                value={signupCountry}
                onChange={(e) => setSignupCountry(e.target.value)}
                // {...registerSignup("country", { required: true })}
              >
                {countryList?.map((c) => (
                  <MenuItem key={c.countryCode} value={c.countryCode}>
                    {c.countryName} ({c.countryCode})
                  </MenuItem>
                ))}
              </Select>
            </Box>

            <Box display={"flex"} alignItems="center" mb={2}>
              <InputLabel
                sx={{
                  fontSize: 14,
                  color: "#000",
                  fontWeight: 700,
                  minWidth: "120px",
                  mr: 2,
                }}
              >
                Phone Number
              </InputLabel>
              <TextField
                fullWidth
                size="small"
                {...registerSignup("phone", { required: true })}
                onChange={(e) => setSignupPhone(e.target.value)}
              />
            </Box>

            {!afterOtpSignupOpen && (
              <Box display="flex" justifyContent="center" my={2}>
                <Button
                  type="submit"
                  sx={{
                    minWidth: "180px",
                    background: "#4d92d9",
                    border: "2px solid #4d92d9",
                    ":hover": {
                      background: "transparent",
                      color: "#4d92d9",
                      transition: "0.4s",
                    },
                  }}
                  variant="contained"
                >
                  CONTINUE
                </Button>
              </Box>
            )}

            {afterOtpSignupOpen && (
              <Box sx={{ mt: 2 }}>
                {/* <Typography variant="subtitle2">
                  Complete registration
                </Typography> */}

                <Box display={"flex"} alignItems="center" mb={2} mt={2}>
                  <InputLabel
                    sx={{
                      fontSize: 14,
                      color: "#000",
                      fontWeight: 700,
                      minWidth: "120px",
                      mr: 2,
                    }}
                  >
                    Name
                  </InputLabel>
                  <TextField
                    placeholder="Name"
                    fullWidth
                    size="small"
                    value={registeredName}
                    onChange={(e) => setRegisteredName(e.target.value)}
                    // {...registerSignup("name", { required: true })}
                  />
                </Box>

                <Box display={"flex"} alignItems="center" mb={2}>
                  <InputLabel
                    sx={{
                      fontSize: 14,
                      color: "#000",
                      fontWeight: 700,
                      minWidth: "120px",
                      mr: 2,
                    }}
                  >
                    Email
                  </InputLabel>
                  <TextField
                    fullWidth
                    size="small"
                    value={registeredEmail}
                    onChange={(e) => setRegisteredEmail(e.target.value)}
                    sx={{ mb: 1 }}
                    placeholder="E-Mail Address"
                  />
                </Box>

                <Box display={"flex"} alignItems="center" mb={2}>
                  <InputLabel
                    sx={{
                      fontSize: 14,
                      color: "#000",
                      fontWeight: 700,
                      minWidth: "120px",
                      mr: 2,
                    }}
                  >
                    OTP
                  </InputLabel>
                  <TextField
                    fullWidth
                    size="small"
                    sx={{ mb: 1 }}
                    placeholder="OTP"
                    onChange={(e: any) => setSignupPassword(e.target.value)}
                  />
                </Box>

                {/* <TextField
                  fullWidth
                  size="small"
                  label="OTP (simulated)"
                  sx={{ mt: 1 }}
                /> */}

                <Box display="flex" justifyContent="center" my={2}>
                  <Button
                    fullWidth
                    variant="contained"
                    sx={{
                      mt: 2,
                      maxWidth: "180px",
                      background: "#4d92d9",
                      border: "2px solid #4d92d9",
                      ":hover": {
                        background: "transparent",
                        color: "#4d92d9",
                        transition: "0.4s",
                      },
                    }}
                    onClick={handleSubmitRegistration}
                  >
                    SUBMIT
                  </Button>
                </Box>
              </Box>
            )}
          </Box>
        </DialogContent>
      </Dialog>

      <Dialog
  open={openForgotOtpPopup}
  onClose={() => {
    setOpenForgotOtpPopup(false);
  }}
  maxWidth="sm"
  fullWidth
>
  <DialogTitle
    sx={{ position: "relative", pr: 5, fontSize: 18, color: "#0085CA" }}
  >
    Forgot Password OTP
    <IconButton
      onClick={() => {
        setOpenForgotOtpPopup(false);
      }}
      sx={{ position: "absolute", right: 8, top: 8 }}
    >
      <CloseIcon />
    </IconButton>
  </DialogTitle>

  <DialogContent dividers sx={{ py: 4, px: 6 }}>
    <Box component="form">
      <InputLabel sx={{ fontSize: 14, color: "#000", fontWeight: 700 }}>
        OTP
      </InputLabel>

      <TextField
        fullWidth
        size="small"
        sx={{ mb: 3 }}
        value={forgotOtp}
        onChange={(e) => setForgotOtp(e.target.value)}
      />

      <Button
        onClick={handleSubmitForgotOtp}
        fullWidth
        variant="contained"
        sx={{
          textTransform: "capitalize",
          border: "2px solid #4d92d9",
          background: "#4d92d9",
          ":hover": {
            background: "transparent",
            color: "#4d92d9",
          },
        }}
      >
        Submit
      </Button>
    </Box>
  </DialogContent>
</Dialog>

<Dialog
  open={openNewPasswordPopup}
  onClose={() => setOpenNewPasswordPopup(false)}
  maxWidth="sm"
  fullWidth
>
  <DialogTitle sx={{ position: "relative", pr: 5, fontSize: 18, color: "#0085CA" }}>
    Reset Password
    <IconButton
      onClick={() => setOpenNewPasswordPopup(false)}
      sx={{ position: "absolute", right: 8, top: 8 }}
    >
      <CloseIcon />
    </IconButton>
  </DialogTitle>

  <DialogContent dividers sx={{ py: 4, px: 6 }}>
    <Box>

      {/* Country Code Display */}
      <InputLabel sx={{ fontSize: 14, color: "#000", fontWeight: 700 }}>
        Mobile Number
      </InputLabel>
      <TextField
        fullWidth
        size="small"
        disabled
        sx={{ mb: 3 }}
        value={forgotCountry + forgotPhone}
      />

      {/* New Password */}
      <InputLabel sx={{ fontSize: 14, color: "#000", fontWeight: 700 }}>
        New Password
      </InputLabel>
      <TextField
        fullWidth
        type="password"
        size="small"
        sx={{ mb: 3 }}
        value={newPassword}
        onChange={(e) => setNewPassword(e.target.value)}
      />

      {/* Confirm Password */}
      <InputLabel sx={{ fontSize: 14, color: "#000", fontWeight: 700 }}>
        Confirm Password
      </InputLabel>
      <TextField
        fullWidth
        type="password"
        size="small"
        sx={{ mb: 3 }}
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
      />

      <Button
        onClick={handleResetPassword}
        fullWidth
        variant="contained"
        sx={{
          textTransform: "capitalize",
          border: "2px solid #4d92d9",
          background: "#4d92d9",
          ":hover": { background: "transparent", color: "#4d92d9" },
        }}
      >
        Update Password
      </Button>
    </Box>
  </DialogContent>
</Dialog>


    </>
  );
};

export default Navbar;
